import classNames from 'classnames';
import { ComponentProps, ReactNode } from 'react';
import { Size } from '../../types';
import setDenaliAttribute from '../../utils/setDenaliAttribute';
import styles from '../CheckboxGroup/CheckboxGroup.module.scss';
import CheckboxRadioLabel from '../CheckboxRadioLabel/CheckboxRadioLabel';
import InputField from '../InputField';
import Radio from '../Radio';

type Props = {
  className?: string;
  columnLayout?: boolean;
  disabled?: boolean;
  errorText?: ComponentProps<typeof InputField>['errorText'];
  helperText?: ComponentProps<typeof InputField>['helperText'];
  labelText?: ComponentProps<typeof InputField>['labelText'];
  labelTextVariant?: ComponentProps<typeof InputField>['labelTextVariant'];
  name: string;
  onChange: (value: string) => void;
  options: {
    disabled?: ComponentProps<typeof Radio>['disabled'];
    selected: ComponentProps<typeof Radio>['selected'];
    subtext?: ReactNode;
    text: ReactNode;
    value: string;
  }[];
  radioClassName?: string;
  size?: Size<'sm' | 'md'>;
  verticalAlignment?: 'center' | 'top';
};

const RadioGroup = ({
  className,
  columnLayout,
  disabled,
  errorText,
  helperText,
  labelText,
  labelTextVariant,
  name,
  onChange,
  options,
  radioClassName,
  size = 'md',
  verticalAlignment
}: Props) => {
  // TODO add optional <fieldset> instead for accessibility

  const radioOptions = options.map(option => {
    const { subtext, text, disabled: optionDisabled, selected, value } = option;

    return (
      <Radio
        key={value}
        className={radioClassName}
        disabled={disabled || optionDisabled}
        labelElement={<CheckboxRadioLabel text={text} subtext={subtext} size={size} disabled={disabled || optionDisabled} />}
        name={name}
        onChange={onChange}
        selected={selected}
        size={size}
        value={value}
        verticalAlignment={verticalAlignment}
      />
    );
  });

  return (
    <InputField
      {...setDenaliAttribute('RadioGroup')}
      className={classNames(styles.container, className)}
      disabled={disabled}
      errorText={errorText}
      helperText={helperText}
      labelText={labelText}
      labelTextVariant={labelTextVariant}
      role="radiogroup"
      useDivInsteadOfLabel
    >
      {columnLayout ? <div className={styles.columns}>{radioOptions}</div> : radioOptions}
    </InputField>
  );
};

export default RadioGroup;
